import { Api } from './api';

export class UsersApi {
    private static readonly PATH = '/users';

    constructor(private readonly m_api: Api) {}

    public async makeProfit() {
        return this.m_api.post(`${UsersApi.PATH}/make-profit`, {});
    }
}